import { Divider } from "@material-ui/core";
import { CSSProperties, useEffect, useState } from "react";

import { IDialogChildComponent } from "../../../reducers/dialog";
import useAPI from "../../../yoello-lib/modules/API/useAPI";
import { DialogOrderTypes, IProcessedOrdersDetails, OrderOptions } from "../constants";
import APIDefinitions from '../../../yoello-lib/modules/API/APIDefs';
// import { useAuth0 } from '../../../yoello-lib/modules/auth/Auth0';
import SquareLink from "../SquareLink";

import Styles from "../../../scss/orderDetails.module.scss";

import { IReduxAppState } from "../../../reducers";
import { useSelector } from "react-redux";
import { OrderStatus } from "../../../interfaces/EOrderStatus";
import { PartiallyRefundedOrderDetails } from "../OrderDetailsUI/PartiallyRefundedOrderDetails";
import { CustomerDetails } from "../OrderDetailsUI/CustomerDetails";
import { OrderItems } from "../OrderDetailsUI/OrderItems";
import { PricingDetails } from "../OrderDetailsUI/PricingDetails";
import { OrderDetails } from "../OrderDetailsUI/OrderDetails";
import { OrderStatusDetails } from "../OrderDetailsUI/OrderStatusDetails";
import { OrderDetailsActions } from "../OrderDetailsUI/OrderDetailsActions";
import { PaymentProcessor } from "../../menu/payments/types.d";
import { IMultiDialogChildren } from "../../dialogRoutes/MultiDialogRoute";
import { ICollectionPoint } from "../../ordersSetting/Forms/CollectionPointEntity";
import { useAuthenticationContext } from "../../../yoello-lib/modules/auth/AuthenticationContext";
import { FormLoadingWrapper } from "../../util/FormLoadingWrapper";
import ListLoading from "../../util/Loading";

export interface IActionButton {
    style: CSSProperties;
    label: string;
    onClick: (callback: () => void) => void;
}

interface IOrderData {
    hash_id: string;
    integration_object_id: string;

}



interface IOrderDetailsDialog extends IDialogChildComponent, IMultiDialogChildren {
    orderID: string;
    dialogActionButtons?: (dialogOrderDetails: IProcessedOrdersDetails) => IActionButton[];
    collectionPoints: ICollectionPoint[];
    dialogType: DialogOrderTypes;
    orderAPI: any;
    setMessageOptions: (value: boolean) => void;
    id: string;
}

export function OrderDetailsDialog(props: IOrderDetailsDialog) {
    const { retrieveAccessToken } = useAuthenticationContext();
    const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const venue = useSelector((state: IReduxAppState) => state.venue[selectedVenueId]);
    const { apiData: dialogOrderDetails, isLoading: isDetailsLoading } = useAPI<IProcessedOrdersDetails>(APIDefinitions.order, retrieveAccessToken, { preQuery: selectedVenueId, query: props.orderID ?? props.id });
    const { apiData: ordersData, isLoading: ordersLoading } = useAPI<IOrderData[]>(APIDefinitions.orders, retrieveAccessToken, { preQuery: selectedVenueId });
    const [integrationObjectId, setIntegrationObjectId] = useState<string>();
    const isPartiallyRefundedOrder = dialogOrderDetails?.placed_order.placed_order_order_status === OrderStatus.PARTIALLY_REFUNDED;
    const isRefundedOrder = dialogOrderDetails?.placed_order.placed_order_order_status === OrderStatus.REFUNDED;
    useEffect(() => {
        const thisOrder = ordersData?.find((order: IOrderData) => {
            return order.hash_id === dialogOrderDetails?.placed_order.placed_order_hash_id
        });
        setIntegrationObjectId(thisOrder?.integration_object_id);
    }, [ordersData, ordersLoading, dialogOrderDetails])

    function displayDiscountCode(): boolean {
        const { placed_order } = dialogOrderDetails!;
        const discountDetails: any = placed_order?.placed_order_discount_frozen || '';
        // display discounts only for discounted items
        if (discountDetails) {
            return true;
        } else return false
    }

    return <div>
        {isDetailsLoading ? <FormLoadingWrapper padding='5rem 10rem'><ListLoading/></FormLoadingWrapper> :
            <div>
                <div data-component-name="OrderDetailsDialog" className={`${Styles.orderDetailsDialogContainer} ${isPartiallyRefundedOrder ? Styles.partiallyRefundedWrapper : undefined}`}>
                    <div>
                        <div className={Styles.orderDetailsLeftColumn}>
                            <OrderStatusDetails placed_order={dialogOrderDetails?.placed_order!} />
                            <OrderDetails 
                                placed_order={dialogOrderDetails?.placed_order!} 
                                collectionPoints={props.collectionPoints}
                                orderOnly={dialogOrderDetails?.placed_order?.placed_order_order_option === OrderOptions.ORDER_ONLY}
                            />
                            <OrderDetailsActions placed_order={dialogOrderDetails?.placed_order!} inOrder={dialogOrderDetails?.in_order!}
                                dialogType={props.dialogType} orderAPI={props.orderAPI} collectionPoints={props.collectionPoints}
                                setMessageOptions={props.setMessageOptions} onClose={props.onClose}
                                orderDetails={dialogOrderDetails!}
                                path={props.routePath}
                                history={props.history}
                                orderOnly={dialogOrderDetails?.placed_order?.placed_order_order_option === OrderOptions.ORDER_ONLY}
                            />
                            {venue.venueData?.payment_processor === PaymentProcessor.SQUARE && integrationObjectId && <div className={Styles.SquareLink}><SquareLink squareOrderId={integrationObjectId} /></div>}
                            <Divider style={{ margin: "1.25rem 0" }} />
                            <CustomerDetails orderDetails={dialogOrderDetails!} />
                            <Divider style={{ margin: "1.25rem 0" }} />
                            {
                                isPartiallyRefundedOrder && <>
                                    <PartiallyRefundedOrderDetails totalRefunded={dialogOrderDetails?.placed_order.total_refund_amount!} totalTax={dialogOrderDetails?.placed_order.tax_refund_amount!} />
                                    <Divider style={{ margin: "1.25rem 0" }} />
                                </>
                            }
                        </div>
                        <PricingDetails placed_order={dialogOrderDetails?.placed_order!}
                            orderOnly={dialogOrderDetails?.placed_order?.placed_order_order_option === OrderOptions.ORDER_ONLY}
                        />
                    </div>
                    <OrderItems
                        inOrder={dialogOrderDetails?.in_order!}
                        isPartiallyRefundedOrder={isPartiallyRefundedOrder}
                        isSquare={venue.venueData?.payment_processor === PaymentProcessor.SQUARE}
                        hasDiscountCode={displayDiscountCode()}
                        isRefundedOrder={isRefundedOrder}
                    />
                </div>
            </div>
        }
    </div >
}